import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";

const QueBank = () => {
  const [formData, setFormData] = useState({
    StudentName: "", // ✅ Matching MongoDB schema
    Class: "",
    Subject: "",
    Chapter: "",
    Board: "",
    Mobile: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
  
    try {
      const response = await axios.post(
        "/api/user/quebankenquiry",
        formData,
        {
          headers: {
            "Content-Type": "application/json", // ✅ REQUIRED HEADER
          },
        }
      );
  
      if (response.status === 201) {
        setIsSubmitted(true);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      setError("Error submitting form. Please check your network.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        background: "linear-gradient(135deg, #f8f9fa, #dfe6e9)",
        padding: 4,
      }}
    >
      <Card sx={{ maxWidth: 600, width: "100%", borderRadius: 3, boxShadow: 6, padding: 3 }}>
        <CardContent>
          {!isSubmitted ? (
            <>
              <Typography variant="h5" textAlign="center" color="primary" fontWeight="bold" mb={3}>
                📄 Fill To Get Your Question Bank
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Box sx={{ padding: 2 }}>
                  {[
                    { label: "Student Name", name: "StudentName", type: "text" },
                    { label: "Class", name: "Class", type: "text" },
                    { label: "Subject", name: "Subject", type: "text" },
                    { label: "Chapter", name: "Chapter", type: "text" },
                    { label: "Board", name: "Board", type: "text" },
                    { label: "Whatsapp No", name: "Mobile", type: "tel" },
                  ].map((field, index) => (
                    <TextField
                      key={index}
                      label={field.label}
                      name={field.name}
                      type={field.type}
                      value={formData[field.name]}
                      onChange={handleChange}
                      required
                      fullWidth
                      variant="outlined"
                      margin="normal"
                    />
                  ))}
                </Box>

                <Box display="flex" justifyContent="center" mt={3}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ fontWeight: "bold", height: 50, width: 200 }}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                  </Button>
                </Box>
              </form>
            </>
          ) : (
            <Box textAlign="center" sx={{ padding: 2 }}>
              <Typography variant="h5" color="success.main" fontWeight="bold">
                🎉 Form Submitted!
              </Typography>
              <Typography variant="body1" color="text.primary" mt={2}>
                📩 You will receive your <strong>Question Bank</strong> on your WhatsApp soon!
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                📞 Please make sure your mobile number is correct.
              </Typography>
              <Box display="flex" justifyContent="center" mt={3}>
                <Button variant="contained" color="success">
                  ✅ Okay
                </Button>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default QueBank;
